export default __webpack_public_path__ + "ux.24522c52.png";